import React from 'react';
import { isEmpty } from 'lodash';

import DataMapTable from 'js/components/data_maps/DataMapTable';
import NoContentTextView from 'js/components/elements/NoContentTextView';
import AclTabViewContainer from 'js/components/elements/aclView/AclTabViewContainer';
import { ACL_RESOURCE_TYPE_LOOKUPS } from 'js/constants/aclConstants';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';
import { ROUTE_DATA_MAPS } from 'js/constants/pathnames';
import { SUPPORT_KEY_LOOKUP } from 'js/constants/supportPageKeys';
import { SearchFilterTypes, SearchFilterViews } from 'js/constants/visibilityFilters';
import UIUtils from 'js/lib/UIUtils';
import RoutePrefixContext from 'new/contexts/RoutePrefixContext';
import { BannerDescription } from 'new/elements/BannerDescription';

import './DataMapDashboard.scss';
import DataMapCardOverviewTabContainer from './cards/DataMapCardOverviewTabContainer';

const availableFilterTypes = [
  SearchFilterTypes.ID,
  SearchFilterTypes.NAME,
  SearchFilterTypes.DESCRIPTION,
  SearchFilterTypes.TAG,
];

class DataMapDashboard extends React.Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);

    this._handleCreateClicked = this._handleCreateClicked.bind(this);
  }

  componentDidMount() {
    this.props.setContextualSupport(SUPPORT_KEY_LOOKUP);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.dataMapId && prevProps.dataMapId !== this.props.dataMapId) {
      this.props.loadDataMap(this.props.dataMapId, this.props.aclQueryMode);
    }
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_LOOKUP);
  }

  render() {
    const { dataMaps, filters, isLoading, onlyTableView, loadDataMapListing } = this.props;
    const resourceId = UIUtils.extractParamFromURL(this.props.match);
    const detailViewTabs = [
      {
        tabName: 'Overview',
        tabElement: <DataMapCardOverviewTabContainer />,
      },
      {
        tabName: 'Access',
        tabElement: <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_LOOKUPS} />,
      },
    ];

    let noContentView = null;

    if (!isLoading && isEmpty(dataMaps)) {
      if (resourceId) {
        noContentView = (
          <NoContentTextView
            title={<div>We are sorry, we could not find this lookup.</div>}
            subtitle={
              <div>
                Please reload the page or file a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support.
              </div>
            }
          />
        );
      } else {
        noContentView = <NoContentTextView title={<div>You do not have any lookups.</div>} />;
      }
    }

    return (
      <div>
        <BannerDescription
          title="Lookups"
          description="Efficiently manage relationships between values, such as Zip Code - City listings. Create static lookups here to manually control relationship changes, or automatically update relationships by sending a Nexset to a Dynamic Lookup destination."
          to={`${this.context}${ROUTE_DATA_MAPS}/new`}
          actionTitle="New Static Lookup"
        />
        <DataMapTable
          view={SearchFilterViews.DATA_MAPS}
          isLoading={isLoading}
          urlId={resourceId}
          filters={filters}
          data={dataMaps}
          detailViewTabs={detailViewTabs}
          availableFilterTypes={availableFilterTypes}
          noContentView={noContentView}
          loadData={loadDataMapListing}
        />
      </div>
    );
  }

  _handleCreateClicked() {
    this.props.history.push(`${this.context}${ROUTE_DATA_MAPS}/new`);
  }
}

DataMapDashboard.defaultProps = {
  onlyTableView: false,
};

export default DataMapDashboard;
